import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

import { GridRecord } from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  receiptForGrid,
  ReceiptSearch,
} from '../../components/Receipt/ReceiptsSearch';

interface ExamReceiptsListProps {
  examId?: string;
  refresh?: boolean;
}

export const ExamReceiptsList: React.FC<ExamReceiptsListProps> = ({
  examId,
  refresh,
}) => {
  const spd = useSpdCore();
  const [receipts, setReceipts] = useState<GridRecord[]>([]);

  useEffect(() => {
    if (!examId) {
      return;
    }
    spd.receipts
      .getByExamId(examId)
      .then(result => setReceipts(result.map(receiptForGrid)))
      .catch(() => setReceipts([]));
  }, [spd.receipts, examId, refresh]);

  const getData = useCallback(
    async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: 'ASC' | 'DESC',
    ) => {
      const start = (pageNumber - 1) * pageSize;
      const sorted = orderBy
        ? receipts.sort((a, b) => {
            const aVal = a.values[orderBy];
            const bVal = b.values[orderBy];
            const aNum = Number(aVal);
            const bNum = Number(bVal);
            const comparison =
              !isNaN(aNum) && !isNaN(bNum)
                ? aNum - bNum
                : String(aVal).localeCompare(String(bVal));
            return orderDirection === 'DESC' ? -comparison : comparison;
          })
        : receipts;
      return sorted.slice(start, start + pageSize);
    },
    [receipts],
  );

  const getCount = useCallback(async () => receipts.length, [receipts]);

  if (receipts.length === 0) {
    return null;
  }

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="mb-0">Paragony do badania</Card.Title>
      </Card.Header>
      <Card.Body>
        <ReceiptSearch
          getData={getData}
          getCount={getCount}
          withFilterInColumns={false}
          showFilter={false}
          withHistory={false}
        />
      </Card.Body>
    </Card>
  );
};
